/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

const PAL_ERROR_BASE = 0x0600;

export const PALErrorCodes = Object.freeze({
  /**
   * Indicates that the PAL session initialization failed.
   */
  SESSION_INIT_FAILURE: PAL_ERROR_BASE + 0x01,
});
